export function TMap() {
    return new Promise(function (resolve, reject) {
        window.init = function () {
            resolve(qq)//注意这里
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://map.qq.com/api/js?v=2.exp&callback=init&key=QLIBZ-JCBC4-PLLUU-XHWOK-7RZSZ-O3B2I";
        script.onerror = reject;
        document.head.appendChild(script);
    })
}


// WEBPACK FOOTER //
// ./src/common/js/map.js